import styled from '@emotion/styled';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { IconButton } from '@mui/material';
import {
  fluidSlideAnimationVariants,
  staticSlideAnimationVariants,
} from 'animations/layout/sidebarAnimations';
import { motion } from 'framer-motion';
import { useAtom } from 'jotai';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { isSidebarOpenAtom } from 'store/private/layout/layoutAtoms';

import { CategoryLinks } from '../CategoryLinks/CategoryLinks';
import { MenuBar } from '../MenuBar/MenuBar';
import { SidebarActions } from './SidebarActions/SidebarActions';

export const staticSidebarWidth = 50;
export const fluidSidebarWidth = 250;

export const Sidebar = props => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen] = useAtom(isSidebarOpenAtom);

  const settingClickHandler = () => {
    if (pathname.startsWith('/operation')) {
      navigate('/operation/default-settings');
    }
  };

  return (
    <Container>
      <StaticBar
        animate={isSidebarOpen ? 'open' : 'closed'}
        variants={staticSlideAnimationVariants}
      >
        <PerfectScrollbar
          options={{ suppressScrollX: true, useBothWheelAxes: false }}
        >
          <StaticBarContent>
            <SidebarActions />
            <CategoryLinks direction="column" />
            <IconButton onClick={() => ''}>
              <SettingsOutlinedIcon
                sx={{ color: 'white' }}
                onClick={settingClickHandler}
              />
            </IconButton>
          </StaticBarContent>
        </PerfectScrollbar>
      </StaticBar>
      <FluidBar
        animate={isSidebarOpen ? 'open' : 'closed'}
        variants={fluidSlideAnimationVariants}
      >
        <MenuBar />
      </FluidBar>
    </Container>
  );
};

const bgGradientColor = `linear-gradient(#010F19, #072B46, #083658, #06253D)`;

const Container = styled.aside`
  ${({ theme }) => ({
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  })}
`;

const StaticBar = styled(motion.div)`
  width: ${staticSidebarWidth}px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  overflow: hidden;
  z-index: 33;
  background-image: ${bgGradientColor};
`;

const StaticBarContent = styled.div`
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding: 5px 0;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const FluidBar = styled(motion.div)`
  width: ${fluidSidebarWidth}px;
  height: 100%;
  padding: 30px 0 0 12px;
  position: fixed;
  top: 0;
  right: ${staticSidebarWidth}px;
  z-index: 22;
  background-image: ${bgGradientColor};
`;

const AppLogoBox = styled.div`
  height: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 26px;
`;

const AppLogo = styled.img`
  width: 102px;
  transform: rotate(-90deg) translateX(14px);
`;
